import React from 'react';
import styles from './CoverCollection.module.scss';
import { collectionTypeOptions } from '@src/constants';
import { getMediaAbsolutePath } from '@src/services/File';
import type { DraggableProvided, DraggableStateSnapshot } from '@src/utils/componentCasts';
import { DragDropContext, Droppable, Draggable } from '@src/utils/componentCasts';
import useDragScrolling from '../customize-units/card/useDragScrolling';
import { useDrag } from 'react-dnd';
import LessonIcon from 'src/assets/icons/lesson_icon.svg?react';
import ContentVideo from '../content-video/ContentVideo';
import Button from '../button/Button';

type Props = {
  collection: any;
  type?: string;
  source?: string;
  target?: string;
  draggableProvided?: DraggableProvided;
  snapshot?: DraggableStateSnapshot;
  onCardClick?: (sllLessons: any[]) => void;
  onEditCollection?: (collection: any) => void;
}

function CoverCollection(props: Props) {

  const { collection, type="type", onEditCollection, onCardClick } = props

  const {
    name,
    bannerImage,
    bannerVideo,
    grade,
    sllLessons,
    collectionType
} = collection;

  const count = sllLessons?.length || 0;

  const isThemeType = collectionType === collectionTypeOptions[2].value

  const collectionCover = (type: String) => {
    switch (type) {
      case collectionTypeOptions[0].value: {
        return (
            <div className={styles.lessonContainer}>
                <p className={styles.individualLessonTitle}>Displayed as Individual Lessons</p>
                <p className={styles.gradeTitle}>{grade}</p>
            </div>);
      }
      case collectionTypeOptions[1].value: {
        return (
            <div className={styles.imageContainer}>
                {!!bannerImage ? (
                    <img src={getMediaAbsolutePath(bannerImage) || ""} alt="cover" width={'100%'}/>
                ) : null}
                {!bannerImage && bannerVideo ? (
                    <ContentVideo data={bannerVideo} metaData={bannerVideo?.metaData} autoPlay={false} isCollection={true} />
                ) : null}
            </div>
        );
      }
      case collectionTypeOptions[2].value: {
        return (
          <>
            <div className={styles.themeContainerRectangle1}></div>
            <div className={styles.themeContainerRectangle2}></div>
            <div className={styles.themeContainerRectangle3}></div>
            <div className={styles.themeContainer}>
              <p className={styles.titleText}>Displays as Theme</p>
              <p className={styles.gradeTitle}>{grade}</p>
            </div>
          </>
        );
      }
      default: {
        return (
            <div className={styles.imageContainer}>
                {!!bannerImage ? (
                    <img src={getMediaAbsolutePath(bannerImage) || ""} alt="cover" width={'100%'}/>
                ) : null}
                {!bannerImage && bannerVideo ? (
                    <ContentVideo data={bannerVideo} metaData={bannerVideo?.metaData} autoPlay={false} isCollection={true}/>
                ) : null}
            </div>
        );
      }
    }
  }

  const { addEventListenerForWindow, removeEventListenerForWindow } = useDragScrolling();

  const [{ opacity, isDragging }, drag] = useDrag(
    () => ({
      type,
      item: () => {
        // like begin drag
        addEventListenerForWindow();
        return { collection }
      },
      end: () => {
        // like end drag
        removeEventListenerForWindow();
      },
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging(),
        opacity: !!monitor.isDragging() ? 0.4 : 1,
      }),
    }),
    [collection, type],
  )

  return (
    <div ref={drag} className={styles.collectionCardContainer} style={{opacity, cursor: isDragging ? 'grabbing' : 'grab'}} onClick={() => onCardClick && onCardClick(sllLessons)}>
        {isThemeType ? (
            <>
                <div className={styles.themeContainerRectangle1}></div>
                <div className={styles.themeContainerRectangle2}></div>
                <div className={styles.themeContainerRectangle3}></div>
            </>
        ) : (
            <>
                <div className={styles.containerRectangle1}></div>
                <div className={styles.containerRectangle2}></div>
                <div className={styles.containerRectangle3}></div>
            </>
        )}
        {collectionCover(collectionType)}
        <div className={styles.lessonMarkContainer}>
            <div className={styles.lessonCountContainer}>
                <LessonIcon />
                <p className={styles.lessonTitle}>
                    {count || 0} Lessons
                </p>
            </div>
            {/* <div className={styles.lessonDurationContainer}>
                <TimerIcon />
                <p className={styles.lessonDurationTitle}>
                    {count || 0} x {duration || 0} mins
                </p>
            </div> */}
        </div>
        <div className={styles.titleContainer}>
            <p className={styles.title}>
                {name || ""}
            </p>
            <Button
                onClick={() => onEditCollection && onEditCollection(collection.id)}
                outline={true}
                className={styles.addBtn}
                label={"Edit"}
                color='orange'
            />
        </div>
       
    </div>
  )
}

export default CoverCollection

